import { withProps, compose } from 'recompose'
import toggle from 'components/common/hoc/toggle'
import withViewHide from 'components/common/hoc/withViewHide'
import CompareTrayMobile from './CompareTrayMobile'

export default compose(
  withViewHide(({ compareTrayShow }) => !compareTrayShow),
  withProps(({ itemsCount }) => ({
    expandedByDefault: true,
    traySummary: `${itemsCount} Tire${itemsCount === 1 ? '' : 's'}`
  })),
  toggle
)(CompareTrayMobile)
